import { Message } from 'element-ui';
export const success = function (message, duration = 3000) {
  Message({
    type: 'success',
    message,
    duration,
  });
};

export const info = function (message, duration = 3000) {
  Message({
    type: 'info',
    message,
    duration,
  });
};

export const warn = function (message, duration = 3000) {
  Message({
    type: 'warning',
    message,
    duration,
  });
};

export const error = function (message, duration = 3000) {
  Message({
    type: 'error',
    message,
    duration,
  });
};

export const showApiErrorMessage = function (res) {
  if (res?.message) {
    Message({
      type: 'error',
      message: res.message,
    });
  }
};
